module.exports = __webpack_public_path__ + "img/108ne.9f19cc71.svg";